import { IPanel, IPanelProps as FIPanelProps, IPanelStyles, Panel as FPanel } from '@fluentui/react';
import { forwardRef } from 'react';

import { IComponent } from '../../models/components.models';
import { useThemeStyles } from '../../utils/hooks';
import { panelStylesDefault } from './Panel.styles';

export interface IPanelProps extends Omit<FIPanelProps, 'styles'>, IComponent<IPanelStyles> {}

export const Panel = forwardRef<IPanel, IPanelProps>((props, ref) => {
  const { styles, ..._fProps } = props;
  const fProps: FIPanelProps = {
    ..._fProps,
    styles: useThemeStyles<Partial<IPanelStyles>>(panelStylesDefault, styles),
  };
  return <FPanel {...fProps} componentRef={ref as any} data-test={props['data-test'] || 'panel'} />;
});
